import React from 'react';
import ReactDOM from 'react-dom/client';
import Home from '../src/Home'
import AppRotas from './routes';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppRotas/>
  </React.StrictMode>
);


